import { useCallback, useState } from "preact/hooks";
import useAxiosCallback from "../../hooks/useAxiosCallback";
import { getDefaultStateParams } from "./TransactionsUtils";
import moment from "moment";

export default function useTransactionsDownload() {

    const [loadingState, setLoadingState] = useState({
        batchSize: 0,
        bufferSize: 0
    });

    const { batchSize, bufferSize } = { ...loadingState };
    const { isLoading, fetch } = useAxiosCallback();
    const { fileDownloadParams: fs } = getDefaultStateParams();

    const fetchStatistics = useCallback(async (config) => {
        let stats;
        const queryParams = {
          date_from: moment(config?.params?.dateFrom * 1000).format("YYYY-MM-DD HH:mm:ss"),
          date_to: moment(config?.params?.dateTo * 1000).format("YYYY-MM-DD HH:mm:ss"),
        };
        const response = await fetch(
          "/user/flow/stats/summary",
          {
            method: "GET",
            params: queryParams,
          },
          (response) => {
            stats = response.data;
          }, (error) => {
            console.log(error.message);
          }
        );

        return stats;

    })
    const fetchFile = useCallback(async (config) => {
        const limit = fs.defaultDownloadBatchSize;
        let offset = fs.initialDownloadCursorOffset;
        let hasMoreData = true;
        let buffer = [];
        let dataLength = 0;

        const queryParams = {
            limit,
            offset,
            date_from: moment(config?.params?.dateFrom * 1000).format("YYYY-MM-DD HH:mm:ss"),
            date_to: moment(config?.params?.dateTo * 1000).format("YYYY-MM-DD HH:mm:ss"),
            sort: 'created_at:desc',
        };

        if (config?.params?.selectedSearchFilter == 'flow_id') {
            queryParams.flow_id = config?.params?.searchQuery;
        }
        if (config?.params?.selectedSearchFilter == 'person_id') {
            queryParams.person_id = config?.params?.searchQuery;
        }
        if (config?.params?.selectedSearchFilter == 'name') {
            queryParams.person_name = config?.params?.searchQuery;
        }

        config?.params?.selectedFilters.forEach(([filter_type, value]) => {
            if (queryParams[filter_type] !== undefined) {
                queryParams[filter_type] += `,${value}`;
            } else {
                queryParams[filter_type] = value;
            }
        });

        while (hasMoreData) {
            const response = await fetch("/user/journal/sessions/group-by-flow-id", {
                method: "GET",
                params: queryParams
            },
                (response) => {
                    buffer = buffer.concat(response.data);
                    dataLength = response.data.length;
                }, (error) => {
                    console.log(error.message);
                });

            queryParams.offset += limit;

            hasMoreData = dataLength === limit;
        }
        return buffer;

    }, []);
    // const fetchFile = useCallback(async (config) => {

    //     const dateFrom = config?.params?.dateFrom;
    //     const dateTo = config?.params?.dateTo;
    //     const serviceName = config?.params?.serviceName;

    //     let batchSize = fs.defaultDownloadBatchSize;
    //     let cursorOffset = fs.initialDownloadCursorOffset;
    //     let buffer = [], buffer_size = 0;

    //     do {
    //         await fetch("/user/reports/detailed", {
    //             method: "GET",
    //             params: {
    //                 date_from: dateFrom,
    //                 date_to: dateTo,
    //                 service_name: serviceName,
    //                 records_per_page: batchSize,
    //                 page_number: ++cursorOffset,
    //                 include_optional_fields: "true"
    //             }
    //         },
    //             (response) => {
    //                 buffer_size = response.data.total_transactions;
    //                 buffer = buffer.concat(response.data.entries);
    //             }, (error) => {
    //                 console.log(error.message);
    //             }
    //         );

    //         setLoadingState({ batchSize: buffer.length, bufferSize: buffer_size });

    //     } while (buffer.length < buffer_size);

    //     return buffer;

    // }, []);
    return { isLoading, batchSize, bufferSize, fetchFile, fetchStatistics };
}